import { Directive, AfterContentChecked, HostListener } from "@angular/core";

@Directive({
  selector: "textarea[autosize]"
})
export class TextAreaDirective implements AfterContentChecked {
  @HostListener("input", ["$event.target"])
  onInput(textArea: HTMLTextAreaElement) {
    this.setStyles();
  }

  ngAfterContentChecked() {
    this.setStyles();
  }

  setStyles() {}
}
